import { SpecialRow } from "@/data/specials";
import { cn } from "@/components/common/utils";
import { formatRuntime } from "@punchup/utils/formatRuntime";
import { renderRelativeTimestamp } from "@punchup/utils/timestamps";

// The "runtime • published date" meta row shown beneath a special's video.
// Shared by the full special page (VideoWrapper) and the preview page.
export function SpecialRuntimeMeta({
  special,
  className,
}: {
  special: Pick<SpecialRow, "runtime" | "published_at">;
  className?: string;
}) {
  return (
    <div className={cn("text-sm text-gray-400 font-medium mb-2", className)}>
      {formatRuntime(special.runtime)}{" "}
      {special.published_at && (
        <>• {renderRelativeTimestamp(special.published_at)}</>
      )}
    </div>
  );
}
